import { Application, Option } from '../../gql/graphql';
import { selectLeaseHelper } from '../leases/leases.helpers';
import { selectLoanHelper, selectLoanHelperOTB } from '../loans/loans.helpers';

export const getApprovalAmount = (application?: Application): number | null => {
  // if approvalAmount

  if (application?.lease?.options?.length) {
    /**
     * NOTE: In MVP, the highest approval option is automatically selected
     * In post-MVP, there will be an additional screen to select lease term
     * TODO: Remove logic to automatically select lease term in post-MVP
     */
    // get leaseOption with highest approval amount
    const leaseTerm = selectLeaseHelper(application?.lease?.options);
    if (leaseTerm) {
      return parseFloat(leaseTerm.approvedAmount);
    }
  } else if (application?.loan) {
    let selectedLoanProduct: Option;
    if (application?.loan?.isOtb) {
      selectedLoanProduct = selectLoanHelperOTB(application?.loan?.options);
    } else {
      selectedLoanProduct = selectLoanHelper(application?.loan?.options);
    }
    return parseFloat(selectedLoanProduct?.lineAmount.toString());
  }
  return null;
};
